import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HomeService } from '../_services/home.service';
import { LoadingService } from '../_services/loading.service';


@Component({
  selector: 'app-post-assignments',
  templateUrl: './post-assignments.component.html',
  styleUrls: ['./post-assignments.component.scss']
})
export class PostAssignmentComponent {
  @Input() propertyData: any;
  residentialdata: any;
  constructor(private router: Router, private homeService: HomeService, private loadingService: LoadingService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,) { }

  ngOnInit(): void {
    console.log('residentialdata')
  }

  viewDetails(id: number, event: Event) {
    event.stopPropagation();
    this.router.navigate(['/property-details'], { queryParams: { id } });
  }
}

